/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LexiconSchema from './schema.defs.js'

const $nsid = 'com.atproto.lexicon.resolveLexicon'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  nsid: /*#__PURE__*/ l.string({ format: 'nsid' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cid: /*#__PURE__*/ l.string({ format: 'cid' }),
  schema: /*#__PURE__*/ l.ref<LexiconSchema.Main>(
    (() => LexiconSchema.main) as any,
  ),
  uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Resolves an atproto lexicon (NSID) to a schema. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['LexiconNotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
